import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/intake.css";

export default function ToneVoiceForm({ clinicId, formData, setFormData }) {
  const [isEditing, setIsEditing] = useState(true);
  const [loading, setLoading] = useState(true);

  // Local state fallback
  const [toneVoice, setToneVoice] = useState({
    brand_tone: "",
    staff_title: "",
    customer_address: "",
    emoji: null,
  });

  const handleChange = (field, value) => {
    const updated = {
      ...toneVoice,
      [field]: value,
    };
    setToneVoice(updated);
    setFormData((prev) => ({
      ...prev,
      tone_voice: updated,
    }));
  };

  const handleSave = async () => {
    if (!clinicId) {
      alert("Missing clinic ID");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/tone/tone-voice/save`, {
        clinic_id: clinicId,
        ...toneVoice,
      });
      setIsEditing(false);
      alert("Tone & voice preferences saved!");
    } catch (err) {
      console.error("Error saving tone & voice:", err);
      alert("Failed to save tone & voice preferences.");
    }
  };

  const handleEdit = () => setIsEditing(true);

  useEffect(() => {
    if (!clinicId) return;

    const fetchToneVoice = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/tone/tone-voice/get`, {
          params: { clinic_id: clinicId },
        });

        if (res.data.status === "success" && res.data.data) {
          const data = res.data.data;
          setToneVoice(data);
          setFormData((prev) => ({
            ...prev,
            tone_voice: data,
          }));
          setIsEditing(false);
        }
      } catch (err) {
        console.error("Error fetching tone & voice info:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchToneVoice();
  }, [clinicId]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="form-wrapper">
      <div className="form-section-header">
        <h2>7. <span className="section-title">Tone & Voice</span></h2>
        <div className="form-buttons">
          {isEditing ? (
            <button className="blue-button" onClick={handleSave}>Save</button>
          ) : (
            <button className="blue-button" onClick={handleEdit}>Edit</button>
          )}
        </div>
      </div>

      <div className="separator" />

      <div className="form-grid2">
        {/* Brand Tone */}
        <div className="form-field">
          <label>Brand Tone</label>
          <select
            value={toneVoice.brand_tone || ""}
            onChange={(e) => handleChange("brand_tone", e.target.value)}
            disabled={!isEditing}
          >
            <option value="">Select...</option>
            <option value="Formal">Formal</option>
            <option value="Friendly">Friendly</option>
            <option value="Clinical">Clinical</option>
            <option value="Trendy">Trendy</option>
            <option value="Luxury / Premium">Luxury / Premium</option>
            <option value="Warm & Caring">Warm & Caring</option>
            <option value="Energetic">Energetic</option>
            <option value="Minimalist / Direct">Minimalist / Direct</option>
            <option value="Empowering / Uplifting">Empowering / Uplifting</option>
            <option value="Educational / Informative">Educational / Informative</option>
            <option value="Youthful">Youthful</option>
            <option value="Playful">Playful (good for Gen Z-focused clinics)</option>
            <option value="Calming / Reassuring">Calming / Reassuring</option>
          </select>
        </div>

        {/* Staff Title */}
        <div className="form-field">
          <label>AI Should Call Staff</label>
          <select
            value={toneVoice.staff_title || ""}
            onChange={(e) => handleChange("staff_title", e.target.value)}
            disabled={!isEditing}
          >
            <option value="">Select...</option>
            <option value="Provider">Provider</option>
            <option value="Specialist">Specialist</option>
            <option value="Nurse">Nurse</option>
            <option value="Aesthetician">Aesthetician</option>
            <option value="Esthetician">Esthetician</option>
            <option value="Team Member">Team Member</option>
            <option value="Practitioner">Practitioner</option>
            <option value="Doctor">Doctor</option>
            <option value="Assistant">Assistant</option>
            <option value="Staff Member">Staff Member</option>
            <option value="Clinician">Clinician</option>
            <option value="Injectors">Injectors</option>
            <option value="Technician">Technician</option>
          </select>
        </div>

        {/* Customer Address */}
        <div className="form-field">
          <label>Address Customers By</label>
          <select
            value={toneVoice.customer_address || ""}
            onChange={(e) => handleChange("customer_address", e.target.value)}
            disabled={!isEditing}
          >
            <option value="">Select...</option>
            <option value="First Name">First Name (e.g., "Hi Emily")</option>
            <option value="Title + Last Name">Title + Last Name (e.g., "Hello Ms. Chen")</option>
            <option value="Full Name">Full Name (e.g., "Good morning Emily Chen")</option>
            <option value="Nickname">Nickname (e.g., "Hey Em")</option>
            <option value="No Name">No Name (e.g., "Hi there!")</option>
          </select>
        </div>
      </div>

      {/* Emoji Usage */}
      <div style={{ width: "1000px", margin: "0 auto" }}>
        <div className="form-field radio-group-inline">
          <label>Emoji Usage</label>
          <div className="radio-options">
            <label>
              <input
                type="radio"
                name="emoji"
                checked={toneVoice.emoji === true}
                onChange={() => handleChange("emoji", true)}
                disabled={!isEditing}
              /> Yes
            </label>
            <label>
              <input
                type="radio"
                name="emoji"
                checked={toneVoice.emoji === false}
                onChange={() => handleChange("emoji", false)}
                disabled={!isEditing}
              /> No
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

